export default __webpack_public_path__ + "static/icon-tile-bold-dont-99005d94841f329a32d314791f0e2e59.png";